<template>
  <div class="facilitator">
    <!-- 服务商 -->
    <!-- 公司名称 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        公司名称
      </div>
      <div class="userinput" style="float: left">
        <input type="text" placeholder="请输入公司名称" ref="companyName" />
      </div>
    </div>
    <!-- 公司logo -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 100px;
          line-height: 40px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        公司logo
      </div>
      <div style="width: 400px; overflow: hidden; float: left">
        <div style="width: 100%; overflow: hidden">
          <el-upload
            class="avatar-uploader"
            action="/v1/cloud/common/upload/img"
            :show-file-list="false"
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="coverImage" :src="coverImage" class="avatar" />
            <div style="width: 170px; height: 100px" v-show="!coverImage">
              <img
                src="../../static/common/upload_image.png"
                style="
                  dispaly: block;
                  width: 34px;
                  height: 33px;
                  margin: 0px 67px;
                  position: absolute;
                  left: 0px;
                  top: 24px;
                "
              />
              <div
                style="
                  color: #3476C1;
                  position: absolute;
                  left: 0px;
                  top: 67px;
                  width: 170px;
                  text-align: center;
                "
              >
                点击此处上传
              </div>
            </div>
          </el-upload>
          <!-- <div style="width:218px;float:left;height:100px;margin-left:10px;">
                        <div style="font-size:12px;line-height:12px;margin-top:43px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(154,154,154,1);">logo 为非必填项</div>
                    </div> -->
          <div
            style="width: 218px; float: left; height: 100px; margin-left: 10px"
            v-show="!coverImage"
          >
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 43px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              可上传png、jpg、gif、svg等格式的图片
            </div>
          </div>
          <div
            style="width: 218px; float: left; height: 100px; margin-left: 10px"
            v-show="coverImage"
          >
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 33px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              可上传png、jpg、gif、svg等格式的文件
            </div>
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 10px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              如需更换图片，请点击图片可再次上传
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 统一社会信用代码/法人代码 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        统一社会信用代码/法人代码
      </div>
      <div class="userinput" style="float: left">
        <input
          type="text"
          placeholder="请输入社会信用代码/法人代码"
          ref="socialCreditCode"
        />
      </div>
    </div>
    <!-- 法人姓名 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        法人姓名
      </div>
      <div class="userinput" style="float: left">
        <input type="text" placeholder="请输入法人姓名" ref="realName" />
      </div>
    </div>
    <!-- 法人身份证号 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        法人身份证号
      </div>
      <div class="userinput" style="float: left">
        <input type="text" placeholder="请输入法人身份证号" ref="cardNum" />
      </div>
    </div>
    <!-- 企业成立日期 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        企业成立日期
      </div>

      <div class="iview-picker">
        <DatePicker
          type="date"
          v-model="startDate"
          placeholder="请输入企业成立日期"
          style="width: 350px"
        ></DatePicker>
      </div>
    </div>
    <!-- 企业经营期限 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        企业经营期限
      </div>
      <div class="iview-picker">
        <DatePicker
          type="date"
          v-model="limitDate"
          placeholder="请输入企业经营期限"
          style="width: 350px"
        ></DatePicker>
      </div>
    </div>
    <!-- 公司网址 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        公司网址
      </div>
      <div class="userinput" style="float: left">
        <input type="text" placeholder="请输入公司网址" ref="officialWebsite" />
      </div>
    </div>
    <!-- 所在地区 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 50px;
          line-height: 50px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        所在地区
      </div>
      <div style="width: 350px; float: left" class="infor-area">
        <Select
          v-model="formValidate.province"
          style="width: 110px; margin-right: 8px; height: 50px"
          @on-change="changeProvince"
          :placeholder="defaultAddress.province"
        >
          <Option
            v-for="item in provinceArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="formValidate.city"
          style="width: 110px; margin-right: 8px; height: 50px"
          @on-change="changeCity"
          :placeholder="defaultAddress.city"
        >
          <Option
            v-for="item in cityArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="formValidate.county"
          style="width: 110px; margin-right: 0px; height: 50px"
          @on-change="changeCounty"
          :placeholder="defaultAddress.county"
        >
          <Option
            v-for="item in countyArr"
            :value="item.encoded"
            :key="item.encoded"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
    </div>
    <!-- 通讯详细地址 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        通讯详细地址
      </div>
      <div class="userinput" style="float: left">
        <input
          type="text"
          placeholder="请输入通讯详细地址（精确到门牌号）"
          ref="address"
        />
      </div>
    </div>
    <!-- 联系电话 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        联系电话
      </div>
      <div class="userinput" style="float: left">
        <input type="text" placeholder="请输入您的联系电话" ref="phoneNum" />
      </div>
    </div>
    <!-- 联系邮箱 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 38px;
          line-height: 38px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        联系邮箱
      </div>
      <div class="userinput" style="float: left">
        <input
          type="text"
          placeholder="请输入您的联系邮箱"
          ref="email"
          @blur="emailBlur"
        />
      </div>
    </div>
    <!-- 行业 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 50px;
          line-height: 50px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        所属行业
      </div>
      <div class="iselect" style="float: left">
        <Select
          v-model="sel_territory"
          style="width: 200px"
          placeholder="请选择所属行业"
        >
          <Option
            v-for="item in industryList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
    </div>
    <!-- 经营范围 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 50px;
          line-height: 50px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        经营范围
      </div>
      <div style="float: left; width: 350px">
        <textarea
          placeholder="请输入经营范围（最多不超过500字）"
          v-model="individualResume"
          style="
            width: 350px;
            height: 200px;
            background: rgba(250, 250, 250, 1);
            border: 1px solid rgba(238, 238, 238, 1);
            border-radius: 4px;
            outline: none;
            padding: 14px 9px;
          "
          @blur="individualResumeFn"
        >
我是一个文本框。</textarea
        >
      </div>
    </div>
    <!-- 营业执照 -->
    <div style="overflow: hidden; margin-top: 20px">
      <div
        style="
          float: left;
          width: 430px;
          text-align: right;
          margin-right: 30px;
          height: 100px;
          line-height: 40px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #666666;
        "
      >
        营业执照
      </div>
      <div style="width: 400px; overflow: hidden; float: left">
        <div style="width: 100%; overflow: hidden">
          <el-upload
            class="avatar-uploader"
            action="/v1/cloud/common/upload/img/business-license"
            :show-file-list="false"
            :on-success="handleSuccess2"
            :on-error="handleError2"
            :before-upload="beforeAvatarUpload2"
          >
            <img v-if="coverImage2" :src="coverImage2" class="avatar" />
            <div style="width: 170px; height: 100px" v-show="!coverImage2">
              <img
                src="../../static/common/upload_image.png"
                style="
                  dispaly: block;
                  width: 34px;
                  height: 33px;
                  margin: 0px 67px;
                  position: absolute;
                  left: 0px;
                  top: 24px;
                "
              />
              <div
                style="
                  color: #3476C1;
                  position: absolute;
                  left: 0px;
                  top: 67px;
                  width: 170px;
                  text-align: center;
                "
              >
                点击此处上传
              </div>
            </div>
          </el-upload>
          <!-- <div style="width:218px;float:left;height:100px;margin-left:10px;">
                        <div style="font-size:12px;line-height:12px;margin-top:43px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(154,154,154,1);">logo 为非必填项</div>
                    </div> -->
          <div
            style="width: 218px; float: left; height: 100px; margin-left: 10px"
            v-show="!coverImage2"
          >
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 43px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              可上传png、jpg、gif、svg等格式的图片
            </div>
          </div>
          <div
            style="width: 218px; float: left; height: 100px; margin-left: 10px"
            v-show="coverImage2"
          >
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 33px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              可上传png、jpg、gif、svg等格式的文件
            </div>
            <div
              style="
                font-size: 12px;
                line-height: 12px;
                margin-top: 10px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: rgba(154, 154, 154, 1);
              "
            >
              如需更换图片，请点击图片可再次上传
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 清除浮动 -->
    <div style="clear: both"></div>
    <div class="c-go" @click="submitFn()">提交信息</div>
  </div>
</template>

<script>
import areasData from "@/assets/areas.json";

export default {
  name: "facilitator",
  data() {
    return {
      sel_territory: "", //行业
      industryList: [],
      individualResume: "",
      emailCheck: true, //邮箱校验
      startDate: "", //开始日期
      limitDate: "", //期限
      //省市区数据
      provinceArr: areasData.data,
      cityArr: [],
      countyArr: [],
      formValidate: {
        province: "",
        city: "",
        county: "",
      },
      defaultAddress: {
        province: "请选择",
        city: "请选择",
        county: "请选择",
      },
      provinceCode: 0,
      cityCode: 0,
      countyCode: 0, //地区编码
      //上传图片
      coverImage: "",
      logoImage: "",
      coverImage2: "",
      logoImage2: "",
    };
  },
  methods: {
    realNameBlur() {},
    emailBlur() {
      //判断邮箱格式是否正确
      let email = this.$refs.email.value;
      if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.$refs.email.value)) {
        this.emailCheck = false;
        this.$message.error("邮箱格式错误");
      } else {
        this.emailCheck = true;
      }
    },
    handleError(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      } else if (res.status == 400) {
        this.$message.error("文件太大，请压缩后上传");
      }
    },
    handleSuccess(res, file) {
      this.coverImage = URL.createObjectURL(file.raw);
      this.logoImage = res;
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 0.2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    handleError2(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      } else if (res.status == 400) {
        this.$message.error("文件太大，请压缩后上传");
      }
    },
    handleSuccess2(res, file) {
      this.coverImage2 = URL.createObjectURL(file.raw);
      this.logoImage2 = res;
    },
    beforeAvatarUpload2(file) {},
    //提交 完善信息
    submitFn() {
      let param = {
        position: 4, // 身份 0.教师 1.有机构学员 2.无机构学员 3专家 4 服务商
        companyName: this.$refs.companyName.value, // 公司名称
        companyLogo: this.logoImage, // 公司logo
        socialCreditCode: this.$refs.socialCreditCode.value, // 统一社会信用代码
        realName: this.$refs.realName.value, //法人姓名
        cardNum: this.$refs.cardNum.value, // 法人身份证号
        companyFoundDate: this.startDate, // 公司建立时间
        companyBusinessDateLimit: this.limitDate, // 公司经营期限
        officialWebsite: this.$refs.officialWebsite.value, // 公司官网地址
        address: this.$refs.address.value, // 通讯地址
        phoneNum: this.$refs.phoneNum.value,
        email: this.$refs.email.value,
        industryId: this.sel_territory, //行业
        businessScope: this.individualResume, // 经营范围
        businessLicense: this.logoImage2, // 营业执照

        provinceCode: this.provinceCode, //省
        cityCode: this.cityCode, //市
        areaCode: this.countyCode, //区
      };
      // console.log(33,param)
      this.$axios
        .post("/v1/cloud/user/perfectMsg", param, {})
        .then(({ data }) => {
          if (data === true) {
            localStorage.setItem("completeStatus", "1"); //是否完善信息
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    individualResumeFn() {
      if (this.individualResume.length > 500) {
        this.$message.error("最多不超过500字！");
      } else {
      }
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (this.formValidate.province == this.provinceArr[i].encoded) {
          this.cityArr = this.provinceArr[i].cityRespList;
          this.formValidate.county = "";
          this.countyArr = [];
        }
      }
      this.provinceCode = val;
    },
    changeCity(val) {
      for (var i = 0; i < this.cityArr.length; i++) {
        if (this.formValidate.city == this.cityArr[i].encoded) {
          this.countyArr = this.cityArr[i].countyRespList;
        }
      }
      this.cityCode = val;
    },
    changeCounty(s) {
      console.log("区", s, this.formValidate.county);
      this.countyCode = s;
    },
  },
  created() {
    //行业  industry
    this.$axios.get("/v1/cloud/common/industry").then(({ data }) => {
      if (data) {
        data.shift();
        this.industryList = data;
      }
    });
  },
  mounted() {},
};
</script>

<style lang="less">
.facilitator {
  width: 100%;
  height: auto;
  .userinput {
    width: 350px;
    height: 50px;
    border: 1px solid rgba(238, 238, 238, 1);
    border-radius: 4px;
    padding-left: 9px;
    .getcode {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #3476C1;
      border-radius: 4px;
      float: right;
      margin: 5px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    img {
      display: block;
      float: left;
      width: 18px;
      height: 18px;
      margin-left: 16px;
      margin-top: 8px;
      margin-right: 12px;
    }
    input {
      float: left;
      width: 300px;
      height: 100%;
    }
  }
  .iview-picker {
    .ivu-input {
      height: 50px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
    }
    .ivu-input:focus {
      box-shadow: none;
    }
    .ivu-date-picker-focused input {
      box-shadow: none;
    }
    .ivu-input-prefix i,
    .ivu-input-suffix i {
      line-height: 50px;
    }
  }
  .c-go {
    margin-top: 50px;
    margin-bottom: 37px;
    margin-left: 460px;
    width: 350px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #3476C1;
    border-radius: 4px;
    cursor: pointer;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
input::placeholder {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.facilitator .iview-picker .ivu-input {
  height: 40px;
  background: #fff;
}
.facilitator .iview-picker .ivu-input::placeholder {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.facilitator .iview-picker .ivu-input-suffix i {
  line-height: 40px;
}
</style>